import React from "react";
//#region types
import { IconDefinitionConstants } from "utils/constants";
import { TranslationKeys } from "translations";
import { ShowMoreButtonProps } from "models/propTypes/commonPropTypes";
//#endregion
//#region components
import StyledButton from "../buttons/styledButton";
import Icon from "../icon";
//#endregion
import { LocalizationHelperInstance } from "utils/helpers";
import cssExports from "theme/styles/main.module.scss";

const ShowMoreButton: React.FC<ShowMoreButtonProps> = (props) => {
  const { onClick, expandDirectionUp } = props;

  return (
    <StyledButton
      secondary
      className={cssExports.showMoreButton}
      onClick={onClick}
      size={"sm"}
      endIcon={
        expandDirectionUp ? (
          <Icon icon={IconDefinitionConstants.WArrowCollapse} />
        ) : (
          <Icon icon={IconDefinitionConstants.WArrowExpand} />
        )
      }
    >
      {props.children ?? LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.ShowMore)}
    </StyledButton>
  );
};

export default ShowMoreButton;
